module.exports = "https://r.zoocdn.com/_next/static/txts/vulnerability-disclosure-public-key.static-b8b16b1976d38ecb92b5fb0a7da72693.txt";